var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:('height:'+ _vm.height)},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"40","color":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }